// src/utils/permissions.js
export const canViewMegaMenu = (user) => {
	if (!user) return false;

	// حالت تست محدود
	//const allowedUserIds = [1, 12, 25];
	const allowedUserIds = [1];

	// حالت Role-based
	//if (user.role === "ADMIN") return true;

	// حالت تست آزمایشی
	if (allowedUserIds.includes(user.id)) return true;

	return false;
};
